import { useState } from 'react';
import { Tabs, Tab } from '@mui/material';
import TooltipTab from '../../../util/TooltipTab';
import { tooltips } from '../../tooltips';
import EquipmentPoints from './EquipmentPoints';
import FeedsEquipment from './FeedsEquipment';
import FeedsLocations from './FeedsLocations';

const EquipmentDetails = ({ building, stagingEquipment, stagingPoints, equipment }) => {
  const [tab, setTab] = useState(0);

  return (
    <>
      <Tabs value={tab} onChange={(event, newValue) => setTab(newValue)}>
        <Tab className="tab" label="Points" />
        <TooltipTab
          message={equipment.published ? null : tooltips.equipmentRelationshipsTab}
          label="Feeds Equipment"
          disabled={!equipment.published}
        />
        <TooltipTab
          message={equipment.published ? null : tooltips.equipmentRelationshipsTab}
          label="Feeds Locations"
          disabled={!equipment.published}
        />
      </Tabs>
      {tab === 0 ? (
        <EquipmentPoints building={building} stagingPoints={stagingPoints} equipment={equipment} />
      ) : null}
      {tab === 1 ? (
        <FeedsEquipment
          building={building}
          equipment={equipment}
          stagingEquipment={stagingEquipment}
        />
      ) : null}
      {tab === 2 ? <FeedsLocations building={building} equipment={equipment} /> : null}
    </>
  );
};

export default EquipmentDetails;
